/** Cognito lambda hook tunnel URL (legacy `config-amplify.js` root `clientMetadata`). */
export function getCognitoClientMetadata() {
  const endpointOverride = process.env.REACT_APP_NGROK_API_URL
  if (!endpointOverride) {
    return undefined
  }
  return { endpointOverride }
}

/** v6 has no global configure clientMetadata; pass on each auth API (same effect as Amplify v4). */
export function withCognitoClientMetadataOptions(options = {}) {
  const clientMetadata = getCognitoClientMetadata()
  if (!clientMetadata) {
    return options
  }
  return {
    ...options,
    clientMetadata: { ...clientMetadata, ...options.clientMetadata },
  }
}
